import React from 'react';
import { Rect } from 'react-konva';
import {
  WALL_EXT_COLOR, WALL_INT_COLOR, WALL_SELECTED_COLOR,
  WALL_THICKNESS, WALL_INT_THICKNESS, HITBOX_EXPAND,
} from '../constants';

/**
 * External walls — 4 rectangles forming the perimeter.
 */
export function ExternalWalls({ x, y, w, h }) {
  const wt = WALL_THICKNESS;
  return (
    <>
      {/* Top */}
      <Rect x={x} y={y} width={w} height={wt} fill={WALL_EXT_COLOR} listening={false} />
      {/* Bottom */}
      <Rect x={x} y={y + h - wt} width={w} height={wt} fill={WALL_EXT_COLOR} listening={false} />
      {/* Left */}
      <Rect x={x} y={y} width={wt} height={h} fill={WALL_EXT_COLOR} listening={false} />
      {/* Right */}
      <Rect x={x + w} y={y} width={wt} height={h} fill={WALL_EXT_COLOR} listening={false} />
    </>
  );
}

/**
 * Internal wall — a line/rect that can be selected and (in future) dragged.
 */
export function InternalWall({
  wall,
  x1, y1, x2, y2,
  isSelected,
  editMode,
  onSelect,
}) {
  const wt = WALL_INT_THICKNESS;
  const color = isSelected ? WALL_SELECTED_COLOR : WALL_INT_COLOR;

  if (wall.dir === 'h') {
    // Horizontal wall
    const wx = Math.min(x1, x2);
    const wy = y1 - wt / 2;
    const ww = Math.abs(x2 - x1);
    return (
      <>
        <Rect
          x={wx}
          y={wy}
          width={ww}
          height={wt}
          fill={color}
          listening={editMode}
          onClick={(e) => {
            e.cancelBubble = true;
            onSelect && onSelect(wall.id);
          }}
        />
        {/* Expanded hitbox in edit mode */}
        {editMode && (
          <Rect
            x={wx}
            y={wy - HITBOX_EXPAND}
            width={ww}
            height={wt + HITBOX_EXPAND * 2}
            fill="transparent"
            onClick={(e) => {
              e.cancelBubble = true;
              onSelect && onSelect(wall.id);
            }}
          />
        )}
      </>
    );
  } else {
    // Vertical wall
    const wx = x1 - wt / 2;
    const wy = Math.min(y1, y2);
    const wh = Math.abs(y2 - y1);
    return (
      <>
        <Rect
          x={wx}
          y={wy}
          width={wt}
          height={wh}
          fill={color}
          listening={editMode}
          onClick={(e) => {
            e.cancelBubble = true;
            onSelect && onSelect(wall.id);
          }}
        />
        {editMode && (
          <Rect
            x={wx - HITBOX_EXPAND}
            y={wy}
            width={wt + HITBOX_EXPAND * 2}
            height={wh}
            fill="transparent"
            onClick={(e) => {
              e.cancelBubble = true;
              onSelect && onSelect(wall.id);
            }}
          />
        )}
      </>
    );
  }
}
